import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '@/componentes/ui/table';
import { Valor } from '@/componentes/valor';
import type { ProjetoAdmin } from '@/dados';

import { Capitulo, NaoPreenchido } from './ficha';

/* Os projetos orçados, do mais recente para trás.
 *
 * Sem coluna de margem nem de preço sugerido: o painel lê o que a empresa
 * preencheu, e o veredito do projeto dela é dela. */
export function Projetos({ projetos }: { projetos: ProjetoAdmin[] }) {
  return (
    <Capitulo titulo="Projetos" descricao="Os cinquenta mais recentes.">
      {projetos.length === 0 ? (
        <NaoPreenchido>Nenhum projeto orçado.</NaoPreenchido>
      ) : (
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead scope="col">Projeto</TableHead>
                <TableHead scope="col" className="text-right">Módulos</TableHead>
                <TableHead scope="col" className="text-right">Potência</TableHead>
                <TableHead scope="col" className="text-right">Kit</TableHead>
                <TableHead scope="col" className="text-right">Venda</TableHead>
                <TableHead scope="col">Atualizado</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {projetos.map((projeto) => (
                <TableRow key={projeto.id}>
                  <TableHead scope="row" className="max-w-64 truncate font-normal">
                    {projeto.nome_projeto}
                  </TableHead>
                  <TableCell className="text-right">
                    <Valor valor={projeto.quantidade_modulos} formato="inteiro" tamanho="apoio" />
                  </TableCell>
                  <TableCell className="text-right">
                    <Valor valor={projeto.kwp_sistema} decimais={2} sufixo="kWp" tamanho="apoio" />
                  </TableCell>
                  <TableCell className="text-right">
                    <Valor valor={projeto.custo_kit} formato="moeda" tamanho="apoio" />
                  </TableCell>
                  <TableCell className="text-right">
                    <Valor valor={projeto.valor_venda} formato="moeda" tamanho="apoio" />
                  </TableCell>
                  <TableCell className="whitespace-nowrap">
                    <Valor valor={projeto.atualizado_em} formato="data" tamanho="apoio" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </Capitulo>
  );
}
